import { render } from "./Profile.vue?vue&type=template&id=3e2dd668&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=3e2dd668&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e2dd668"

export default script